import { useState } from "react";
import { toast } from "sonner";
import { CheckCheck, Inbox, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import DraftCard from "@/components/autopilot/DraftCard";
import api, { errMsg } from "@/lib/api";

export default function DraftList({ drafts, reload }) {
  const [busy, setBusy] = useState(false);
  const bulk = async (action) => {
    if (action === "reject" && !window.confirm(`Tolak semua ${drafts.length} draf?`)) return;
    setBusy(true);
    try {
      const r = await api.post("/autopilot/drafts/bulk", { action });
      toast.success(action === "approve" ? `${r.data.count} post diluluskan & masuk giliran` : `${r.data.count} draf ditolak`);
      reload();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <section className="panel fade-up p-6" data-testid="autopilot-drafts-card">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h2 className="flex items-center gap-2 font-bold"><Inbox className="h-4 w-4 text-primary" /> Menunggu kelulusan <span className="rounded-full bg-primary/15 px-2 py-0.5 text-xs text-primary" data-testid="autopilot-drafts-count">{drafts.length}</span></h2>
        {drafts.length > 0 && (
          <div className="flex gap-2">
            <Button size="sm" onClick={() => bulk("approve")} disabled={busy} data-testid="autopilot-approve-all-btn"><CheckCheck className="mr-1.5 h-4 w-4" />Luluskan semua</Button>
            <Button size="sm" variant="ghost" className="text-red-300" onClick={() => bulk("reject")} disabled={busy} data-testid="autopilot-reject-all-btn"><XCircle className="mr-1.5 h-4 w-4" />Tolak semua</Button>
          </div>
        )}
      </div>
      {!drafts.length && <p className="mt-6 text-center text-sm text-muted-foreground" data-testid="autopilot-drafts-empty">Tiada draf menunggu. Draf baharu muncul di sini setiap hari dalam mod kelulusan.</p>}
      <div className="mt-4 grid gap-3 lg:grid-cols-2" data-testid="autopilot-drafts-list">
        {drafts.map((d) => <DraftCard key={d.id} d={d} onDone={reload} />)}
      </div>
    </section>
  );
}
